import { FC } from "react";
import { AuthWrapper, Button, Input, PasswordStrengthChecker } from "@components";
import { useControllers } from "./useController";

export const CreatePasswordPage: FC = () => {
    const {
        password,
        confirmPassword,
        isLoading,
        createPasswordError,
        isValidPassword, setIsValidPassword,
        setPassword,
        setConfirmPassword,
        handleCreatePassword,
    } = useControllers();

    return (
        <AuthWrapper>
            <div className="p-4 max-w-md mx-auto">
                <h1 className="text-lg md:text-2xl font-semibold text-center text-secondary mb-6">
                    Création du mot de passe
                </h1>

                <p className="text-center text-gray-600">
                    Entrez votre nouveau mot de passe pour votre compte.
                </p>

                <div className="space-y-4 mt-6">
                    <Input
                        type="password"
                        placeholder="Nouveau mot de passe"
                        className="input input-bordered rounded-full"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Input
                        type="password"
                        placeholder="Confirmer le mot de passe"
                        className="input input-bordered rounded-full"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {
                        createPasswordError &&
                        <p className="text-red-600 text-sm">
                            {createPasswordError?.message}
                        </p>
                    }
                    {
                        password && (
                            <PasswordStrengthChecker
                                password={password}
                                confirmPassword={confirmPassword}
                                onValidityChange={setIsValidPassword}
                            />
                        )
                    }
                    <Button
                        onClick={handleCreatePassword}
                        type="button"
                        className="w-full"
                        disabled={isLoading || !isValidPassword}
                    >
                        {isLoading ? "Création..." : "Créer mon mot de passe"}
                    </Button>
                </div>
            </div>
        </AuthWrapper >
    );
};
